import { GetInteriorsResponse } from "@1games-ru/region-shared/dist/backend/requests/interior";
import { groupBy } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { TextInput } from "@/shared/ui";
import useGetInteriors from "@/domains/createEntity/hooks/useGetInteriors";
import CreateEntityInteriorListItem from "@/domains/createEntity/components/CreateEntityInteriorListItem";
import CreateEntityScroll from "@/domains/createEntity/components/CreateEntityScroll";
import CreateEntityTitle from "@/domains/createEntity/components/CreateEntityTitle";

type Props = {
  onClose: () => void;
};

export default function CrateEntityInteriorList({ onClose }: Props) {
  const [interiors, setInteriors] = useState<GetInteriorsResponse>([]);
  const [search, setSearch] = useState("");
  const { getInteriors } = useGetInteriors();
  const interiorsByType = useMemo(() => {
    return groupBy(interiors, "type");
  }, [interiors]);

  useEffect(() => {
    async function fetchInteriors() {
      const interiorsResponse = await getInteriors();
      setInteriors(interiorsResponse);
    }
    fetchInteriors();
  }, [getInteriors]);

  return (
    <>
      <CreateEntityTitle title="Список интерьеров" onClose={onClose} />

      <TextInput
        placeholder="Поиск"
        className="w-full"
        onChange={(value) => {
          setSearch(value);
        }}
        value={search}
      />

      <CreateEntityScroll>
        <div className="flex flex-col gap-6">
          {Object.entries(interiorsByType).map(([type, list]) => (
            <div key={type} className="space-y-4">
              <div className="text-16 text-white/70 font-semibold border-b border-white/10 pb-2">
                {type}
              </div>

              <div className="space-y-3">
                {list
                  .filter((interior) => interior.name.toLowerCase().includes(search.toLowerCase()))
                  .map((interior) => (
                    <CreateEntityInteriorListItem key={interior.uuid} interior={interior} />
                  ))}
              </div>
            </div>
          ))}
        </div>
      </CreateEntityScroll>
    </>
  );
}
